export enum SitesView {
  TABLE = 'table',
  MAP = 'map',
}

export const SITES_VIEW_URL_PARAM = 'view';
